(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
  tabs= document.querySelectorAll('.custom-tab');
  tabContents= document.querySelectorAll('.custom__tab-content');

  tabs.forEach(function(tab){
      tab.addEventListener('click',function(){

          contentId = this.dataset.contentId;
          content = document.getElementById(contentId);

          tabContents.forEach(function(content){
              content.classList.remove('active');
          });

          tabs.forEach(function(tab){
              tab.classList.remove('active');
          });

          this.classList.add('active');
          content.classList.add('active');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
   
  // Select all elements with class .tab__list
const tabLists = document.querySelectorAll('.tab__list');

// Create a new <ul> element with class .custom--tabs
const ulElement = document.createElement('ul');
ulElement.classList.add('custom--tabs');

// Append each .tab__list element as a child of the new <ul> element
tabLists.forEach(tabList => {
    ulElement.appendChild(tabList);
});

// Replace the existing .custom--tabs with the newly created one
const existingCustomTabs = document.querySelector('.custom--tabs');
if (existingCustomTabs) {
    existingCustomTabs.parentNode.replaceChild(ulElement, existingCustomTabs);
} else {
    // If no .custom--tabs exists, insert the new one where appropriate
    const productInfoBlocks = document.querySelectorAll('.product-info__block-item[data-block-type="custom-tab"]');
    if (productInfoBlocks.length > 0) {
        productInfoBlocks[0].insertBefore(ulElement, productInfoBlocks[0].firstElementChild);
    }
}
  
  tabs= document.querySelectorAll('.custom-tab');
  tabContents= document.querySelectorAll('.custom__tab-content');

  tabs.forEach(function(tab, index){
    if(index == 0){
      getContentId = tab.dataset.contentId;
      getContent = document.getElementById(getContentId);
      tab.classList.add('active');
          getContent.classList.add('active');
    }
      tab.addEventListener('click',function(){

          contentId = this.dataset.contentId;
          content = document.getElementById(contentId);

          tabContents.forEach(function(content){
              content.classList.remove('active');
          });

          tabs.forEach(function(tab){
              tab.classList.remove('active');
          });

          this.classList.add('active');
          content.classList.add('active');
      });
  });


 

  } catch(e) { console.error(e); }
})();
})();
